<app-popup-dependences #edit></app-popup-dependences>
<section>

  <div class="container-fluid p-3">
  <div class="col-12 d-flex justify-content-between ">
    <div>
      <h4 class="text-white h2 my-4 ">Etapas del proyecto: {{ summaryInfoDto.title }}</h4>
    </div>
    <br>
    <div class="d-flex justify-content-center align-items-center">
      <button
        class="badge rounded-pill btn btn-outline-light d-flex align-items-center "
        [routerLink]="['/pdg/project/list/view/', idProject]"
      >
        <i
          class="fa-solid fa-right-from-bracket m-2 fs-6"
          aria-hidden="true"
        ></i>
        <span class="m-2 fs-6">Volver</span>
      </button>
      <button
      class="badge rounded-pill btn btn-outline-light m-2 d-flex align-items-center"
      [routerLink]="['/pdg/project', idProject, 'stages', 'create']"
    >
      <i
        class="fa-solid fa-plus m-2 fs-6"
        aria-hidden="true"
      ></i>
      <span class="m-2 fs-6">Crear etapa</span>
    </button>

     

  

    </div>
  
  </div>

  
    
   

    <div class="backgroundTable mt-3">
      <table
        datatable
        [dtOptions]="dtOptions"
        [dtTrigger]="dtTrigger"
        class="componente-importantes"
      >
        <ng-container *ngIf="projectStages.length == 0"
          >">
          <div class="text-center text-white">
            <h2 class="text-white px-5 mt-5">Sin Registro</h2>
            <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
          </div>
        </ng-container>

        <ng-container *ngIf="projectStages.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Etapa</th>
              <th class="text-white text-center">Estado</th>
              <th class="text-white text-center">Inicio planificado</th>
              <th class="text-white text-center">Termino planificado</th>
              <th class="text-white text-center">Inicio real</th>
              <th class="text-white text-center">Termino real</th>
              <th class="text-white text-center">Dependencia</th>
              <th class="text-white text-center">Desviacion</th>
              <th class="text-white text-center">Acciones</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of projectStages">
              <td class="text-center">
                <span
                  style="width:8rem !important ;"
                  class="badges rounded-pill"
                  [ngStyle]="{ 'background-color': item.color }"
                  >{{ item.name }}</span
                >
              </td>
              <td class="text-center ">{{ item.state }}</td>
              <td class="text-center">{{ item.startDate }}</td>
              <td class="text-center">{{ item.endDate }}</td>
              <td class="text-center">{{ item.realStartDate }}</td>
              <td class="text-center">{{ item.realEndDate }}</td>
              <td class="text-center">{{ item.dependence }}</td>
              <td class="text-center">
                <span
                  style="width:4rem !important ;"
                  class="badges rounded-pill"
                  [ngStyle]="{
                    'background-color':
                      item.deviation >= 0 ? '#DFFAD8' : '#FCF8E3'
                  }"
                >
                  <i
                    *ngIf="item.deviation >= 0"
                    class="fa-solid fa-arrow-turn-up"
                  ></i>
                  <i
                    *ngIf="item.deviation < 0"
                    class="fa-solid fa-arrow-turn-down"
                  >
                  </i>
                  {{ item.deviation }}</span
                >
              </td>

              <td class="text-center">
                <div ngbDropdown class="d-inline-block">
                  <i
                    class="fa-solid fa-gear fa-xl"
                    id="dropdownBasic1"
                    ngbDropdownToggle
                  ></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button (click)="stagesEdit(item , idProject)" ngbDropdownItem>
                      Editar
                    </button>
                    <button ngbDropdownItem (click)="edit.open(item.id)" >Asignar dependencia</button>
                    <button (click)="stageDelete(item.id)" ngbDropdownItem>Eliminar</button>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </ng-container>
      </table>
    </div>
  </div>
</section>
